/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AffinitySearchResultsState, SearchResultSection, SearchResultsRequest } from 'Types/AffinitySearchTypes';
import { PersonCardId } from 'Types/ChatBotV2Types';
import { PersonLinkedinSearch } from 'Types/GlobalSearchResultsTypes';

export const initialState: AffinitySearchResultsState = {
  searchText: '',
  searchResultsPage: 0,
  isAffinitySearchLoading: false,
  isAffinitySearchLoaded: false,
  isPersonExtendedLoaded: false,
  isPersonExtendedLoading: false,
  buyerSearchText: '',
  buyersearchResultsPage: 0,
  isBuyerAffinitySearchLoading: false,
  isbuyerAffinitySearchLoaded: false,
  isbuyerPersonExtendedLoading: false,
  isbuyerPersonExtendedLoaded: false,
  BuyererrorText: '',
  errorText: '',
  peopleSection: {
    title: '',
    type: '',
    count: 0,
    firstCount: 0,
    linkedInCount: 0,
    persons: [],
    followedPersons: [],
  },
  buyerPeopleSection: {
    title: '',
    type: '',
    count: 0,
    firstCount: 0,
    linkedInCount: 0,
    persons: [],
    followedPersons: [],
  },
  isPagination: false,
  selectedPersonId: 0,
  salesPopoverPeopleSection: {},
  salesPopoverLoading: {},
  salesPopoverLoaded: {},
  salesPopoverExtendedLoading: {},
  salesPopoverExtendedLoaded: {},
  salesPopoverResultsPage: {},

  addRowPopoverPeopleSection: {},
  addRowPopoverLoading: {},
  addRowPopoverLoaded: {},
  addRowPopoverExtendedLoading: {},
  addRowPopoverExtendedLoaded: {},
  addRowPopoverResultsPage: {},
};

const useAffinitySearchResultsSlice = createSlice({
  name: 'affinitySearchResults',
  initialState,
  reducers: {
    affinitySearchResultsLoading(state, action: PayloadAction<SearchResultsRequest>) {
      const { payload } = action;
      const { from } = payload;
      state.searchText = payload.query;
      state.searchResultsPage = payload.page || 1;
      if (from === 'buyerSearch') {
        state.isbuyerPersonExtendedLoading = true;
        state.isBuyerAffinitySearchLoading = true;
      } else {
        state.isPersonExtendedLoading = true;
        state.isAffinitySearchLoading = true;
        state.isAffinitySearchLoaded = false;
      }
      state.isPersonExtendedLoaded = false;
      state.errorText = '';
    },
    multiSalesAffinitySearchLoading(state, action: PayloadAction<SearchResultsRequest>) {
      const { payload } = action;
      const { from } = payload;
      if (from === "multiSales") {
        if (payload.searchContext === "sales") {
          state.salesPopoverLoading[payload?.rowId ?? 0] = true;
          state.salesPopoverExtendedLoading[payload?.rowId ?? 0] = true;
          state.salesPopoverResultsPage[payload?.rowId ?? 0] = payload.page || 1;
        } else if (payload.searchContext === "affinity") {
          state.addRowPopoverLoading[payload?.rowId ?? 0] = true;
          state.addRowPopoverExtendedLoading[payload?.rowId ?? 0] = true;
          state.addRowPopoverResultsPage[payload?.rowId ?? 0] = payload.page || 1;
        }

      }
    },
    affinitySearchResultsLoaded(state, action: PayloadAction<SearchResultSection[]>) {
      state.isAffinitySearchLoading = false;
      state.isAffinitySearchLoaded = true;
      state.isPagination = false;
      const { payload } = action;
      if (payload.length > 0) {
        const people = payload[0];
        if (people.type === 'Executives') {
          if (state.peopleSection.persons && people.persons) {
            state.peopleSection = {
              ...people,
              persons: [...state.peopleSection.persons, ...people.persons],
            };
          }
        }
      }
    },
    multiSalesAffinitySearchLoaded(state, action: PayloadAction<{ results: SearchResultSection[]; searchContext?: string; rowId?: number }>) {
      if (action.payload.searchContext === "sales" && action.payload.rowId !== undefined) {
        const { payload } = action
        state.salesPopoverLoading[payload?.rowId ?? 0] = false;
        state.salesPopoverLoaded[payload?.rowId ?? 0] = true;
        if (payload.results.length > 0) {
          const people = payload.results[0];
          if (people.type === "Executives") {
            const existingSection = state.salesPopoverPeopleSection[payload.rowId ?? 0] ?? {
              title: '',
              type: '',
              count: 0,
              firstCount: 0,
              linkedInCount: 0,
              person: [],
              followedPersons: [],
            };
            state.salesPopoverPeopleSection[payload.rowId ?? 0] = {
              ...people,
              persons: [
                ...(existingSection?.persons ?? []),
                ...(people.persons ?? []),
              ]
            }
          }
        }
        return;
      } else if (action.payload.searchContext === "affinity" && action.payload.rowId !== undefined) {
        const { payload } = action;
        state.addRowPopoverLoading[payload?.rowId ?? 0] = false;
        state.addRowPopoverLoaded[payload?.rowId ?? 0] = true;
        if (payload?.results?.length > 0) {
          const people = payload.results[0];
          if (people.type === 'Executives') {
            const existingSection = state.addRowPopoverPeopleSection[payload?.rowId ?? 0] ?? {
              title: '',
              type: '',
              count: 0,
              firstCount: 0,
              linkedInCount: 0,
              persons: [],
              followedPersons: [],
            };
            state.addRowPopoverPeopleSection[payload?.rowId ?? 0] = {
              ...people,
              persons: [
                ...(existingSection?.persons ?? []),
                ...(people.persons ?? []),
              ]
            }
          }
        }
        return;
      }
    },
    buyerAffinitySearchResultsLoaded(state, action: PayloadAction<SearchResultSection[]>) {
      state.isAffinitySearchLoading = false;
      state.isAffinitySearchLoaded = true;
      state.isPagination = false;
      state.isbuyerAffinitySearchLoaded = false;
      state.isbuyerPersonExtendedLoaded = true;
      const { payload } = action;
      if (payload.length > 0) {
        const people = payload[0];
        if (people.type === 'Executives') {
          if (state.buyerPeopleSection.persons && people.persons) {
            state.buyerPeopleSection = {
              ...people,
              persons: [...state.buyerPeopleSection.persons, ...people.persons],
            };
          }
        }
      }
    },
    buyerAffinitySearchResultReset(state) {
      state.buyerSearchText = '';
      state.buyersearchResultsPage = 0;
      state.isBuyerAffinitySearchLoading = false;
      state.isbuyerAffinitySearchLoaded = false;
      state.isbuyerPersonExtendedLoaded = false;
      state.isbuyerPersonExtendedLoading = false;
      state.BuyererrorText = '';
      state.buyerPeopleSection = {
        title: '',
        type: '',
        count: 0,
        firstCount: 0,
        linkedInCount: 0,
        persons: [],
        followedPersons: [],
      };
    },
    affinitySearchResultsError(state, action: PayloadAction<string>) {
      state.isAffinitySearchLoading = false;
      state.isAffinitySearchLoaded = false;
      state.isPersonExtendedLoaded = false;
      state.isPersonExtendedLoading = false;
      state.errorText = action.payload;
      state.isPagination = false;
    },

    affinitySearchResultsPersonExtendedLoaded(state, action: PayloadAction<PersonLinkedinSearch>) {
      const { payload } = action;
      state.isPersonExtendedLoaded = true;
      state.isPersonExtendedLoading = false;

      state.peopleSection.persons = [
        ...(state.peopleSection.persons ?? []),
        ...payload.results,
      ];
      state.peopleSection.linkedInCount = payload.count ?? 0;
    },
    multiSalesAffinitySearchResultsPersonExtendedLoaded(state, action: PayloadAction<{ result: PersonLinkedinSearch, searchContext?: string, rowId?: number }>) {
      const { payload } = action;
      if (payload.searchContext === 'sales' && payload.rowId !== undefined) {
        state.salesPopoverExtendedLoading[payload?.rowId ?? 0] = false;
        state.salesPopoverExtendedLoaded[payload?.rowId ?? 0] = true;

        const existingSection = state.salesPopoverPeopleSection[payload?.rowId] ?? {
          title: '',
          type: '',
          count: 0,
          firstCount: 0,
          linkedInCount: 0,
          persons: [],
          followedPersons: [],
        }
        existingSection.persons = [
          ...(existingSection.persons ?? []),
          ...payload?.result?.results,
        ];
        existingSection.linkedInCount = payload.result.count ?? 0
        return;
      } else if (payload.searchContext === 'affinity' && payload?.rowId !== undefined) {
        state.addRowPopoverExtendedLoading[payload?.rowId ?? 0] = false;
        state.addRowPopoverExtendedLoaded[payload?.rowId ?? 0] = true;

        const exisitngSection = state.addRowPopoverPeopleSection[payload?.rowId] ?? {
          title: '',
          type: '',
          count: 0,
          firstCount: 0,
          linkedInCount: 0,
          persons: [],
          followedPersons: [],
        };
        exisitngSection.persons = [
          ...(exisitngSection.persons ?? []),
          ...payload?.result.results,
        ]
        exisitngSection.linkedInCount = payload.result.count ?? 0
        return;
      }
    },
    affinityBuyerSearchResultsPersonExtendedLoaded(
      state,
      action: PayloadAction<PersonLinkedinSearch>,
    ) {
      const { payload } = action;
      state.isPersonExtendedLoaded = true;
      state.isbuyerPersonExtendedLoading = false;
      state.isBuyerAffinitySearchLoading = false;
      state.buyerPeopleSection.persons = [
        ...(state.buyerPeopleSection.persons ?? []),
        ...payload.results,
      ];

      state.buyerPeopleSection.linkedInCount = payload.count ?? 0;
    },

    affinitySetSelectedPersonId(state, action: PayloadAction<number>) {
      state.selectedPersonId = action.payload;
    },
    personAddedToGroup(state, action: PayloadAction<number>) {
      state.peopleSection.persons?.map((person) => {
        const p = person;

        if (p.personId === action.payload) p.personAdded = !person.personAdded;

        return p;
      });
    },
    setLiveToExecutiveIdAccountPlan(state, action: PayloadAction<PersonCardId>) {
      const { livesearchId, executiveId } = action.payload;
      const updatedSearch = state.peopleSection.persons?.map(
        (person) => (
          person.personId === livesearchId ? { ...person, personId: executiveId } : person),
      );
      state.peopleSection.persons = updatedSearch;
    },
    affinitySearchResultReset: () => initialState,
    affinityPopoverSearchResultsReset(state, action: PayloadAction<{ searchContext?: string, rowId: number }>) {
      const { searchContext, rowId } = action.payload;
      if (searchContext === 'sales' && rowId !== undefined) {
        state.salesPopoverPeopleSection[rowId] = {
          title: '',
          type: '',
          count: 0,
          firstCount: 0,
          linkedInCount: 0,
          persons: [],
          followedPersons: [],
        };
        state.salesPopoverLoading[rowId] = false;
        state.salesPopoverExtendedLoading[rowId] = false;
        state.salesPopoverLoaded[rowId] = false;
        state.salesPopoverExtendedLoaded[rowId] = false;
        state.salesPopoverResultsPage[rowId] = 0;
        return;

      } else if (searchContext === 'affinity' && rowId !== undefined) {
        state.addRowPopoverPeopleSection[rowId] = {
          title: '',
          type: '',
          count: 0,
          firstCount: 0,
          linkedInCount: 0,
          persons: [],
          followedPersons: [],
        };
        state.addRowPopoverLoading[rowId] = false;
        state.addRowPopoverExtendedLoading[rowId] = false;
        state.addRowPopoverExtendedLoaded[rowId] = false;
        state.addRowPopoverLoaded[rowId] = false;
        state.addRowPopoverResultsPage[rowId] = 0;
      }
    },
  },
});

export const { actions, reducer, name: sliceKey } = useAffinitySearchResultsSlice;
